import { selectBrand, useAppSelector } from '@open-tender/cloud'

// Single gate for the SORTS_LOCATIONS_BY_DISTANCE brand flag -- every consumer reads this hook.
const useNearestFirstLocations = (): boolean => {
  const brand = useAppSelector(selectBrand)
  // brand is null until the config response lands, so coerce rather than return it directly.
  return Boolean(brand?.sorts_locations_by_distance)
}

export default useNearestFirstLocations
